import {
  PhoneVerificationScopes,
  usePhoneNumberVerification,
} from '@map/hooks/usePhoneNumberVerification';
import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';
import Button from '@ui/Button';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Cooldown from './Cooldown';

const useStyles = makeStyles(({ spacing }) => ({
  resend: {
    marginTop: spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

type Props = {
  phone: string;
  scope: PhoneVerificationScopes;
};
const Resender: FC<Props> = ({ phone, scope }) => {
  const { classes } = useStyles();
  const [cooldown, setCooldown] = useState(1);
  const { request, sentRequest } = usePhoneNumberVerification();
  const blocked = sentRequest?.error === 'rate_limit';
  const deliveryWarning = sentRequest?.warning === 'delivery_failed';

  const resend = useCallback(
    () => request(phone, scope).then(() => setCooldown((v) => v + 1)),
    [phone, request, scope],
  );
  return (
    <div className={classes.resend}>
      {blocked && (
        <Typography variant="body2" color="error">
          <FormattedMessage id="phone_number_verification.rate_limit" />
        </Typography>
      )}
      {!blocked && deliveryWarning && (
        <Typography variant="body2" align="center" sx={{ marginBottom: 4 }}>
          <FormattedMessage id="phone_number_verification.undelivered_warning" />
        </Typography>
      )}
      {!blocked && (
        <Cooldown running={cooldown} messageIntlKey="phone_number_verification.resend_timeout">
          <Typography variant="body3" align="center" component="p">
            <FormattedMessage id="phone_number_verification.resend_prompt" />
          </Typography>
          <Button variant="tertiary" onClick={resend}>
            <FormattedMessage id="phone_number_verification.resend_button" />
          </Button>
        </Cooldown>
      )}
    </div>
  );
};

export default Resender;
